(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ClientModules", [], factory);
	else if(typeof exports === 'object')
		exports["ClientModules"] = factory();
	else
		root["ClientModules"] = factory();
})(window, function() {
return 